/* eslint-disable import/no-cycle */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {
	authAssignmentsStorageKey,
	authRoleAndPermissionsStorageKey,
	authUserStorageKey,
	oauthUserStorageKey,
	isAuthGuardActive,
	defaultAssignments,
	defaultRolesAndPermissions,
	defaultSystemName,
	authLocalPermissionsStorageKey,
	authSubscription,
	env,
} from '@/configs/main';
import SubscriptionChecker from '@/components/SubscriptionChecker';
import { auth as authApi, branchApi } from '@/services';
import {
	getCurrentBranch,
	getCurrentMerchant,
	getSubscriptions,
} from './WorkspaceHelper';
import { isProxied } from './Utils';

const getCurrentUser = () => {
	let user = null;
	try {
		if (window.targetStorage.getItem(authUserStorageKey)) {
			user = JSON.parse(window.targetStorage.getItem(authUserStorageKey));
		}
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> getCurrentUser error:', error);
	}
	return user;
};

const setCurrentUser = (payload) => {
	try {
		if (payload) {
			window.targetStorage.setItem(authUserStorageKey, JSON.stringify(payload));
		} else {
			window.targetStorage.removeItem(authUserStorageKey);
		}
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> setCurrentUser error:', error);
	}
};

const getAssignments = () => {
	let assignments = defaultAssignments;
	try {
		if (window.targetStorage.getItem(authAssignmentsStorageKey)) {
			assignments = JSON.parse(
				window.targetStorage.getItem(authAssignmentsStorageKey)
			);
		}
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> getCurrentUser error:', error);
	}
	return assignments;
};

const setAssignments = (payload) => {
	try {
		if (payload) {
			window.targetStorage.setItem(
				authAssignmentsStorageKey,
				JSON.stringify(payload)
			);
		} else {
			window.targetStorage.removeItem(authAssignmentsStorageKey);
		}
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> setAssignments error:', error);
	}
};

const getRolesAndPermissions = () => {
	let data = defaultRolesAndPermissions;
	try {
		if (window.targetStorage.getItem(authRoleAndPermissionsStorageKey)) {
			data = JSON.parse(
				window.targetStorage.getItem(authRoleAndPermissionsStorageKey)
			);
		}
	} catch (error) {
		console.error(
			'>>> src/helpers/Utils.js -> getRolesAndPermissions error:',
			error
		);
	}
	return data;
};

const setRolesAndPermissions = (payload) => {
	try {
		if (payload) {
			window.targetStorage.setItem(
				authRoleAndPermissionsStorageKey,
				JSON.stringify(payload)
			);
		} else {
			window.targetStorage.removeItem(authRoleAndPermissionsStorageKey);
		}
	} catch (error) {
		console.error(
			'>>> src/helpers/Utils.js -> setRolesAndPermissions error:',
			error
		);
	}
};

const getLocalPermissions = () => {
	let data = [];
	try {
		if (window.targetStorage.getItem(authLocalPermissionsStorageKey)) {
			data = JSON.parse(
				window.targetStorage.getItem(authLocalPermissionsStorageKey)
			);
		}
	} catch (error) {
		console.error(
			'>>> src/helpers/Utils.js -> getRolesAndPermissions error:',
			error
		);
	}
	return data;
};

const setLocalPermissions = (payload) => {
	try {
		if (payload) {
			window.targetStorage.setItem(
				authLocalPermissionsStorageKey,
				JSON.stringify(payload)
			);
		} else {
			window.targetStorage.removeItem(authLocalPermissionsStorageKey);
		}
	} catch (error) {
		console.error(
			'>>> src/helpers/Utils.js -> setRolesAndPermissions error:',
			error
		);
	}
};

const getCurrentUserForOAuth = () => {
	let user = null;
	try {
		user =
			sessionStorage.getItem(oauthUserStorageKey) != null
				? JSON.parse(sessionStorage.getItem(oauthUserStorageKey))
				: null;
	} catch (error) {
		console.error(
			'>>> src/helpers/Utils.js -> getCurrentUserForOAuth error:',
			error
		);
		user = null;
	}
	return user;
};

const setCurrentUserForOAuth = (payload) => {
	try {
		if (payload) {
			sessionStorage.setItem(oauthUserStorageKey, JSON.stringify(payload));
		} else {
			sessionStorage.removeItem(oauthUserStorageKey);
		}
	} catch (error) {
		console.error(
			'>>> src/helpers/Utils.js : setCurrentUserForOAuth -> error',
			error
		);
	}
};

const checkRole = (role) => {
	const bid = getCurrentBranch()?.branchId;
	let result = false;
	const data = getRolesAndPermissions().list;
	if (data.length > 0) {
		if (bid === '*') {
			result = data[0].roles.includes(role);
		} else {
			const exact = data.find((el) => el.branchId === bid)?.roles;
			if (exact) {
				result = exact.includes(role);
			}
		}
		if (!result) {
			const fuzzy = data.find((el) => el.branchId === '*')?.roles;
			if (fuzzy) {
				result = fuzzy.includes(role);
			}
		}
	}
	return result;
};

const checkRoles = (roles) => {
	if (roles.some((role) => checkRole(role))) {
		return true;
	}
	return false;
};

const checkPermission = (permission, system) => {
	const bid = getCurrentBranch()?.branchId;
	let result = false;
	const data = getRolesAndPermissions().list;
	if (bid) {
		const exactBranch = data.find((el) => el.branchId === bid)?.permissions;
		if (exactBranch) {
			const exact =
				exactBranch.find(
					(el) => el.application === (system || defaultSystemName)
				)?.permissions ?? [];
			result = exact.includes(permission) || exact.includes('*');
		}
	}
	if (!result) {
		let fuzzyBranch = data.find((el) => el.branchId === '*')?.permissions;
		if (!fuzzyBranch && bid === '*' && data.length > 0) {
			fuzzyBranch = data[0].permissions;
		}
		if (fuzzyBranch) {
			const fuzzy =
				fuzzyBranch.find(
					(el) => el.application === (system || defaultSystemName)
				)?.permissions ?? [];
			result = fuzzy.includes(permission) || fuzzy.includes('*');
		}
	}
	return result;
};

const checkPermissions = (permissions, system) => {
	if (permissions.some((permission) => checkPermission(permission, system))) {
		return true;
	}
	return false;
};

const checkLocalPermissions = (permission) => {
	const permissions = getLocalPermissions() || [];
	return permissions.includes(permission) || permissions.includes('Supervisor');
};

const checkSubscription = (product) => {
	const subscriptions = getSubscriptions();
	const matches = subscriptions.filter((el) => el.product === product);
	if (!matches.length) {
		return undefined;
	}
	// Prefer ACTIVE(1), then EXPIRE(2). Ignore INIT/CANCEL/PENDING so an
	// unfinished duplicate subscription cannot shadow a valid one.
	return (
		matches.find((el) => el.status === 1) ||
		matches.find((el) => el.status === 2) ||
		undefined
	);
};

const ProtectedRoute = ({
	component: Component,
	roles = null,
	permissions = null,
	localPermissions = null,
	workspace = null,
	system = null,
	products = null,
	...rest
}) => {
	const setComponent = (props) => {
		// if (!allowLocalMode && (isZiiPOS() || isProxied())) {
		//   return (
		//     <Redirect
		//       to={{
		//         pathname: '/unauthorized',
		//         state: { from: props.location },
		//       }}
		//     />
		//   );
		// }
		if (isAuthGuardActive) {
			const user = getCurrentUser();
			if (user) {
				if (!isProxied()) {
					if (user.isTempPass && user.id > 0) {
						if (props.location.pathname !== '/user/init-password') {
							return (
								<Redirect
									to={{
										pathname: '/user/init-password',
										state: { from: props.location },
									}}
								/>
							);
						}
						return <Component {...props} />;
					}

					// if (
					// 	!user.phone &&
					// 	user.id > 0 &&
					// 	user.email.indexOf('ziicloud.com') === -1 &&
					// 	user.email.indexOf('kamelmedia.com') === -1 &&
					// 	user.email.indexOf('loke.com.au') === -1
					// ) {
					// 	if (props.location.pathname !== '/user/bind-mobile') {
					// 		return (
					// 			<Redirect
					// 				to={{
					// 					pathname: '/user/bind-mobile',
					// 					state: { from: props.location },
					// 				}}
					// 			/>
					// 		);
					// 	}
					// 	return <Component {...props} />;
					// }

					if (workspace) {
						const merchant = getCurrentMerchant();
						const assignments = getAssignments();
						const validMerchant =
							assignments.id === user.id &&
							assignments.list.find(
								(el) => el.merchantId === merchant?.merchantId
							);
						if (!merchant || !validMerchant) {
							return (
								<Redirect
									to={{
										pathname: '/workspace/entrance',
										state: { from: props.location },
									}}
								/>
							);
						}
					}

					// Check subscription status and license
					if (products && products.length > 0) {
						let subscribed = false;
						let subscribedByExpired = false;
						products.some((product) => {
							const temp = checkSubscription(product);
							if (temp) {
								if (temp.status === 1) {
									subscribed = true;
									subscribedByExpired = false;
									return true;
								}
								if (temp.status === 2) {
									subscribed = true;
									subscribedByExpired = true;
								}
							}
							return false;
						});
						if (!subscribed) {
							return <SubscriptionChecker unsubscribed />;
						}
						if (subscribed && subscribedByExpired) {
							return <SubscriptionChecker expired />;
						}
					}

					// Require check roles or permissions
					if (roles || permissions) {
						let checked = false;
						if (permissions) {
							checked = checkPermissions(permissions, system);
						}
						if (!checked && roles) {
							checked = checkRoles(roles);
						}
						if (!checked) {
							return (
								<Redirect
									to={{
										pathname: '/unauthorized',
										state: { from: props.location },
									}}
								/>
							);
						}
					}
				} else if (localPermissions) {
					let checked = false;
					checked = localPermissions.some((permission) =>
						checkLocalPermissions(permission)
					);
					if (!checked) {
						return (
							<Redirect
								to={{
									pathname: '/unauthorized',
									state: { from: props.location },
								}}
							/>
						);
					}
				}

				return <Component {...props} />;
			}

			if (isProxied()) {
				return (
					<Redirect
						to={{ pathname: '/instore-login', state: { from: props.location } }}
					/>
				);
			}

			return (
				<Redirect
					to={{ pathname: '/login', state: { from: props.location } }}
				/>
			);
		}
		return <Component {...props} />;
	};
	return <Route {...rest} render={setComponent} />;
};

const ProtectedRouteOfOAuth = ({ component: Component, ...rest }) => {
	const setComponent = (props) => {
		const currentUser = getCurrentUserForOAuth();
		if (currentUser) {
			return <Component {...props} />;
		}
		return (
			<Redirect
				to={{ pathname: '/oauth/login', state: { from: props.location } }}
			/>
		);
	};
	return <Route {...rest} render={setComponent} />;
};

const setSubscriptionsList = (payload) => {
	try {
		if (payload) {
			window.targetStorage.setItem(authSubscription, JSON.stringify(payload));
		} else {
			window.targetStorage.removeItem(authSubscription);
		}
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> setSubscriptions error:', error);
	}
};

const getSubscriptionsList = () => {
	let subs = null;
	try {
		if (window.targetStorage.getItem(authSubscription)) {
			subs = JSON.parse(window.targetStorage.getItem(authSubscription));
		}
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> getSubscriptions error:', error);
	}
	return subs;
};

// const clearAndLogout = () => {
// 	setCurrentMerchant(null);
// 	setCurrentBranch(null);
// 	setBranchIds(null);
// 	setSubscriptions(null);
// 	setAssignedLicenses(null);
// 	setCurrentUser(null);
// 	setAssignments(null);
// 	setRolesAndPermissions(null);
// 	setLocalPermissions(null);
// 	setReportFilter(defaultReportFilter);
// 	window.location.href = '/login';
// };

const refreshRolesAndPermissions = async (
	history,
	clearWorkspaceAction,
	logoutUserAction,
	changeAssignmentsAction,
	changeMerchantAction,
	changeRolesAndPermissionsAction
	// changeSubscriptionsAction,
	// changeAssignedLicensesAction
) => {
	try {
		const current = getRolesAndPermissions();
		if (current.id < 0 || current.id == null) {
			return;
		}
		if (current.expiry == null || current.expiry < Date.now()) {
			const data = (await authApi.getRolesAndPermissions()).recordList;
			const result = data.filter((el) => el.merchantId === current.mid);
			if (result !== null && result.length > 0) {
				changeRolesAndPermissionsAction({
					list: result,
					id: current.id,
					mid: current.mid,
					expiry: Date.now() + (env === 'production' ? 5 : 0.5) * 60 * 1000,
				});

				const data1 = (await authApi.getAssignments()).recordList;
				changeAssignmentsAction({ list: data1, id: current.id });

				const assignedMerchant = data1.find(
					(el) => el.merchantId === current.mid
				);
				if (!assignedMerchant) {
					clearWorkspaceAction();
					logoutUserAction(history);
					return;
				}
				const assignedBranches = assignedMerchant.branchs;
				const branchesRes = (await branchApi.list(current.mid)).recordList;
				const branches = [];
				branchesRes
					.sort((a, b) => {
						if (a.sort === b.sort) {
							return a.branchName.localeCompare(b.branchName);
						}
						return a.sort - b.sort;
					})
					.forEach((el) => {
						const isAssigned = assignedBranches.find(
							(b) => b.branchId === el.branchId
						);
						if (el.status === 1 && isAssigned) {
							branches.push(el);
						}
					});
				const merchant = getCurrentMerchant();
				changeMerchantAction({ ...merchant, branches });
			} else {
				clearWorkspaceAction();
				logoutUserAction(history);
			}
		}
	} catch (error) {
		console.error(error);
	}
};

const specialForCashPoint = (merchant, user) => {
	if (!merchant || !user) {
		return true;
	}
	// For cash point customer, prevent access.
	return (
		user.id < 0 ||
		merchant.channelId !== 'C0006' ||
		user.email.indexOf('cashpoint.com.au') > -1 ||
		user.email.indexOf('myposzero.com.au') > -1
	);
};

const specialForSmartPay = (merchant, user) => {
	if (!merchant || !user) {
		return true;
	}
	// For cash point customer, prevent access.
	return user.id < 0 || merchant.channelId !== 'C0007'; // SmartPay
};

export {
	getCurrentUser,
	setCurrentUser,
	getAssignments,
	setAssignments,
	getRolesAndPermissions,
	setRolesAndPermissions,
	getLocalPermissions,
	setLocalPermissions,
	getCurrentUserForOAuth,
	setCurrentUserForOAuth,
	ProtectedRoute,
	ProtectedRouteOfOAuth,
	setSubscriptionsList,
	getSubscriptionsList,
	refreshRolesAndPermissions,
	checkRole,
	checkRoles,
	checkPermission,
	checkPermissions,
	checkLocalPermissions,
	checkSubscription,
	specialForCashPoint,
	specialForSmartPay,
};
